import { render, staticRenderFns } from "./drag_test.vue?vue&type=template&id=cb582e28&scoped=true&"
import script from "./drag_test.vue?vue&type=script&lang=js&"
export * from "./drag_test.vue?vue&type=script&lang=js&"
import style0 from "./drag_test.vue?vue&type=style&index=0&id=cb582e28&prod&scoped=true&lang=less&"
import style1 from "./drag_test.vue?vue&type=style&index=1&id=cb582e28&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb582e28",
  null
  
)

export default component.exports